function initFitvids() {
    if ( $('.fitvids, .editor-text').length > 0) {
        $('.fitvids, .editor-text').fitVids();
    }
}